// extracted by mini-css-extract-plugin
module.exports = {"loader_wrap":"styles_loader_wrap__2p5TH","text_content":"styles_text_content__2HZq-"};